import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    card: {
        margin: '0 10px 0 10px',
        backgroundColor: '#EDEDED'
    },
    cardTitle:{
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 'bold'
    },
    cardBody: {
        textAlign: 'left'
    },
    messageTitle: {
        margin: '6px 0 6px 0',
        fontWeight: 'bold'
    },
    cardFooter: {
        textAlign: 'right'
    }
}));

export default useStyles;